// removed by extract-text-webpack-plugin
module.exports = {"base":"Bons_base--C6KPP","base__isNotEnough":"Bons_base__isNotEnough--2CKvP","baseIsNotEnough":"Bons_base__isNotEnough--2CKvP","base__size-small":"Bons_base__size-small--1K_FN","baseSizeSmall":"Bons_base__size-small--1K_FN","base__size-large":"Bons_base__size-large--5vOdT","baseSizeLarge":"Bons_base__size-large--5vOdT","base__isDisabled":"Bons_base__isDisabled--2s_wQ","baseIsDisabled":"Bons_base__isDisabled--2s_wQ","base__before":"Bons_base__before--3HGAM","baseBefore":"Bons_base__before--3HGAM","base__after":"Bons_base__after--1UbEE","baseAfter":"Bons_base__after--1UbEE"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Bons/Bons.css
// module id = 1739
// module chunks = 16